import PropTypes from 'prop-types';

export const Label = (props) => {
  const { htmlFor, ...otherProps } = props;

  return <label htmlFor={htmlFor} {...otherProps} data-testid="Label" />;
};

Label.propTypes = {
  htmlFor: PropTypes.string.isRequired,
};
